import { render, staticRenderFns } from "./modelCreate.vue?vue&type=template&id=a93d7244&"
import script from "./modelCreate.vue?vue&type=script&lang=js&"
export * from "./modelCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports